import {useEffect, useState} from 'react'
import usePost from './usePost';

const useUploadFile = (allowTypes='',path='',type='file') => {
    const [location,setLocation] = useState(null);
    const [loading,setLoading] = useState(false);
    const [error,setError]  = useState(null); 
    const {data:resultUploads,loading:loadingUpload,error:uploadError,postData:upload} = usePost(false);
    const {data:resultdelete,loading:loadingDeleting,postData:deleteItem} = usePost(false);
    const [isMulti,setIsMulti] = useState(false);
    const [multiFileLength,setMultiFileLength] = useState(0);

    const handleDelete = (keyFile) =>{
        const _data = {
            keyFile: keyFile,
        }
        deleteItem(`${process.env.REACT_APP_UPLOADS_API_BASE_URL}/delete`,_data);
    }     
    const handleUpload = async(event) => {
        setLoading(true)
        const file = event.target.files[0] || null;
        if(file){
            if(allowTypes.find(type => {
                // تحقق من نوع الملف مباشرة
                if (type === file.type) return true;
                // تحقق من امتداد الملف إذا كان نوع الملف غير مطابق
                if (file.name.toLowerCase().endsWith('.webp') && (type === 'image/webp' || type === '.webp')) return true;
                // تحقق إذا كان النوع المسموح به هو أي صورة
                if (type === 'image/*' && file.type.startsWith('image/')) return true;
                return false;
            })){
                // if(type === 'image'){
                //     setLocation(URL.createObjectURL(file));
                // }
                const fileName = file.name;
                try {
                    const _formData = new FormData();
                    _formData.append('myfile',file,fileName);
                    upload(`${process.env.REACT_APP_UPLOADS_API_BASE_URL}/${path}`,_formData);
                } catch (error) {
                    setLoading(false);
                    console.error('Error uploading image:', error);
                }
    
            }else{
                setLoading(false);
            }
        }
    };

    const handleMultiUploads = async(event) => {
        setIsMulti(true);
        setLoading(true)
        setMultiFileLength(Object.values(event.target.files).length);
        Object.values(event.target.files).forEach((file,index) => {
                if(file){
                    if(allowTypes.find(type => {
                        // تحقق من نوع الملف مباشرة
                        if (type === file.type) return true;
                        // تحقق من امتداد الملف إذا كان نوع الملف غير مطابق
                        if (file.name.toLowerCase().endsWith('.webp') && (type === 'image/webp' || type === '.webp')) return true;
                        // تحقق إذا كان النوع المسموح به هو أي صورة
                        if (type === 'image/*' && file.type.startsWith('image/')) return true;
                        return false;
                    })){
                        const fileName = file.name;
                        try {                 
                            const _formData = new FormData();
                            _formData.append('myfile',file,fileName);
                            upload(`${process.env.REACT_APP_UPLOADS_API_BASE_URL}/${path}`,_formData);
                            setTimeout(()=>{
                            },5000)
                        } catch (error) {
                            setLoading(false);
                            console.error('Error uploading image:', error);
                        }
                        
                    }else{
                        setLoading(false);
                    }
                }
            
        });
        
    };

    useEffect(() =>{
        if(uploadError){
            setLoading(false);
            setError(uploadError);
        }
    },[uploadError]);

    useEffect(() =>{
        
        if(resultUploads && !isMulti){
            setLoading(false);
            setLocation(resultUploads.data.location)
        }
        if(resultUploads && isMulti){
            setLocation(resultUploads.data.location)
            setMultiFileLength((state) => state -1);
            if(multiFileLength === 1){
                setLoading(false);
            }            
        }
    },[resultUploads]);

    return {
        location,
        loading,
        error,
        handleUpload,
        handleMultiUploads,
        resultdelete,
        loadingDeleting,
        handleDelete
    }
}

export default useUploadFile

